@if (show) {
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog modal-md modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <!-- <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()" [disabled]="busy"></button> -->
        </div>
        <div class="modal-body">
          <p class="mb-1">{{ message }}</p>
          @if (subtext) {
            <p class="small text-muted mb-0">{{ subtext }}</p>
          }
          @if (error) {
            <div class="alert alert-danger mt-2">{{ error }}</div>
          }
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" (click)="onCancel()" [disabled]="busy">{{ cancelText }}</button>
          <button class="btn btn-warning" (click)="onConfirm()" [disabled]="busy">
            @if (!busy) {
              <span>{{ confirmText }}</span>
            }
            @if (busy) {
              <span>
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                {{ confirmText }}...
              </span>
            }
          </button>
        </div>
      </div>
    </div>
  </div>
}

@if (show) {
  <div class="modal-backdrop fade show"></div>
}
